import { createReducer, on, Action } from '@ngrx/store';
import { TooltipMessage } from '@/shared/flow-states-tooltip/flow-states-tooltip.interface';
import { AddNewTooltip, RemoveTooltip, HideTooltip } from './actions';

export type State = TooltipMessage[];

const initialState: TooltipMessage[] = [];

const _reducer = createReducer(
  initialState,
  on(
    AddNewTooltip,
    (state: TooltipMessage[], payload: TooltipMessage) => [...state, payload].reduce<TooltipMessage[]>((outArr, tooltipMessage) => {
      const alreadyInArrayIndex = outArr.findIndex((x)=> x.id === tooltipMessage.id);
      if (alreadyInArrayIndex < 0) {
        outArr.push(tooltipMessage);
      }
      else {
        outArr[alreadyInArrayIndex] = tooltipMessage;
      }
      return outArr;
    }, [])
  ),
  on(
    RemoveTooltip,
    (state: TooltipMessage[], payload: { id: number }) => state.filter((tooltipMessage) => tooltipMessage.id !== payload.id)
  ),
  on(
    HideTooltip,
    (state: TooltipMessage[], payload: { id: number }) => state.map((tooltipMessage) => tooltipMessage.id === payload.id ? { ...tooltipMessage, show: false } : tooltipMessage)
  ),
);

export function reducer(state: typeof initialState = initialState, action: Action) {
  return _reducer(state, action);
}
